import pageData from "@/i18n/json/projects-partners/data.json";
// Components
import CustomLink from "@/components/custom-link";
// Interface
import { IProjectItem } from "./interfaces";
// Tailwind
import {
  wrapper,
  oddContainer,
  evenContainer,
  img,
  subheading,
  heading,
  content,
  description,
  subtext,
  disclaimer,
  button,
} from "./style/project-item";
// Localization
import { useTranslation, Trans } from "react-i18next";
import ContentHeading from "../content-heading";
import scss from "@/styles/pages/projects-partners/projects-partners-bg.module.scss";

const ProjectItem: React.FC<IProjectItem> = ({
  project,
  image,
  index,
  buttons,
}) => {
  const { t } = useTranslation();
  const isOdd = index && index % 2;

  const Buttons = () => (
    <>
      {buttons.map(({ url }, idx) => (
        <CustomLink
          key={`project-item-${index}-button-${idx}`}
          url={url}
          external={true}
        >
          <button className={button} type="button">
            {t(
              `projects-partners.projects-and-partners.projects.${project}.buttons.${idx}.text`
            )}
          </button>
        </CustomLink>
      ))}
    </>
  );
  return (
    <div className={`${wrapper} ${scss[project.toLowerCase()]}`}>
      <div className={isOdd ? oddContainer : evenContainer}>
        <img
          className={img}
          srcSet={`
                ${image.url}/small.webp 420w,
                ${image.url}/small.jpg 420w,
                ${image.url}/medium.webp 733w, 
                ${image.url}/medium.jpg 733w,
                ${image.url}/large.webp 1465w,
                ${image.url}/large.jpg 1465w,
                `}
          sizes={`
                (max-width:736px) 420px,
                (max-width:1280px) 733px,
                1465px
				        `}
          src={`${image.url}/small.jpg`}
          title={image.title}
          alt={image.alt}
        />

        <div className={content}>
          <p className={heading}>
            <Trans components={{ sup: <sup /> }}>
              projects-partners.projects-and-partners.projects.{project}.heading
            </Trans>
          </p>
          <p className={subheading}>
            {t(
              `projects-partners.projects-and-partners.projects.${project}.subheading`
            )}
          </p>

          <div className={"mobile:hidden tablet:block"}>
            <p
              className={`${description} ${
                project.toLowerCase() === "hearza" && scss["description"]
              }`}
            >
              <Trans components={{ sup: <sup /> }}>
                projects-partners.projects-and-partners.projects.{project}
                .description
              </Trans>
            </p>
          </div>

          <div
            className={`${subtext} ${isOdd ? "mobile:pl-4" : "mobile:pr-4"}`}
          >
            {project.toLowerCase() === "hora" ? (
              <div className={"mobile:hidden tablet:block"}>
                <p>
                  {t(
                    `projects-partners.projects-and-partners.projects.${project}.disclaimer.text`
                  )}
                </p>
              </div>
            ) : (
              <ContentHeading
                h="p"
                className={
                  isOdd
                    ? "mobile:justify-start tablet:justify-end"
                    : "mobile:justify-end tablet:justify-start"
                }
                // backdropPosition="mobile:left-2 mobile:top-0 tablet:left-4"
                backdropPosition={
                  isOdd
                    ? "mobile:right-0 mobile:top-0 tablet:left-4 mobile:!h-[95%]"
                    : "mobile:left-1 mobile:top-0 tablet:left-4 mobile:!h-[95%]"
                }
                fontSize="mobile:text-[1.1rem] tablet:text-3xl"
                fontWeight="mobile:font-extrabold tablet:text-3xl"
                background="bg-primary bg-opacity-50"
              >
                {t(
                  `projects-partners.projects-and-partners.projects.${project}.subtext`
                )}
              </ContentHeading>
            )}
          </div>

          {/* button (tablet&desktop) */}
          <div className={"mobile:hidden tablet:block"}>
            <Buttons />
          </div>
        </div>
      </div>
      <div>
        {/* mobile description display*/}
        <div className={"mobile:block tablet:hidden"}>
          <p className={description}>
            <Trans components={{ sup: <sup /> }}>
              projects-partners.projects-and-partners.projects.{project}
              .description
            </Trans>
          </p>
          <div className={disclaimer}>
            {project.toLowerCase() === "hora" && (
              <div className={"mobile:block mobile:text-left tablet:hidden"}>
                <p>
                  {t(
                    `projects-partners.projects-and-partners.projects.${project}.disclaimer.text`
                  )}
                </p>
              </div>
            )}
          </div>
        </div>

        {/* mobile button display*/}
        <div className={"mobile:block tablet:hidden"}>
          <Buttons />
        </div>
      </div>
    </div>
  );
};

const ProjectItems: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div
      className="tablet:mt-4"
      title={t("projects-partners.projects-and-partners.seo.title")}
      aria-label={t("projects-partners.projects-and-partners.seo.aria-label")}
    >
      {pageData["projects-and-partners"].projects.map(
        (item: IProjectItem, index: number) => {
          return <ProjectItem {...item} index={index} key={index} />;
        }
      )}
    </div>
  );
};

export default ProjectItems;
